import { render, staticRenderFns } from "./revenue2.vue?vue&type=template&id=58bde590&"
import script from "./revenue2.vue?vue&type=script&lang=js&"
export * from "./revenue2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports